import React from 'react'

const QuestionIcon = (
  <>
    <path
      d="M8.49984 15.3334C12.5499 15.3334 15.8332 12.0502 15.8332 8.00008C15.8332 3.94999 12.5499 0.666748 8.49984 0.666748C4.44975 0.666748 1.1665 3.94999 1.1665 8.00008C1.1665 12.0502 4.44975 15.3334 8.49984 15.3334Z"
      stroke="#2EB9FF"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M8.49984 12.3334C8.68393 12.3334 8.83317 12.1842 8.83317 12.0001C8.83317 11.816 8.68393 11.6667 8.49984 11.6667C8.31574 11.6667 8.1665 11.816 8.1665 12.0001C8.1665 12.1842 8.31574 12.3334 8.49984 12.3334Z"
      fill="#2EB9FF"
    />
    <path
      d="M8.49984 12.3334C8.68393 12.3334 8.83317 12.1842 8.83317 12.0001C8.83317 11.816 8.68393 11.6667 8.49984 11.6667C8.31574 11.6667 8.1665 11.816 8.1665 12.0001C8.1665 12.1842 8.31574 12.3334 8.49984 12.3334Z"
      stroke="#2EB9FF"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6.8335 4.05861C8.2195 3.44561 10.0135 3.51861 10.6265 4.51061C11.2395 5.50261 10.8158 6.65561 9.76583 7.54394C8.71583 8.43227 8.50016 8.96661 8.50016 9.66661"
      stroke="#2EB9FF"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>
)

export default QuestionIcon
